<template>
  <div class="rgFsT">
    <h2>Facturar</h2>
    <b-form @submit.prevent="facturar">
      <b-row>
        <b-col>
          <b-form-group label="Serie:">
            <b-form-select
              required
              v-model="form.SerieIdentifier"
              :options="series"
              value-field="identifier"
              text-field="descripcion"
            >
              <template #first>
                <b-form-select-option :value="null"
                  >-- Seleccione una serie --</b-form-select-option
                >
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label-class="font-weight-bold"
            label="Data Factura:"
            label-for="dp-fechafra"
          >
            <b-form-datepicker
              id="dp-fechafra"
              v-model="form.FechaFactura"
              @input="changeDP()"
              required
              :state="dateState"
              :locale="locale"
              placeholder="Seleccionar una fecha"
              today-button
              reset-button
              close-button
              class="mb-2"
            >
            </b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Clientes:">
            <b-form-select
              v-model="form.ClienteIdentifier"
              :options="clients"
              value-field="identifier"
              text-field="nombre"
            >
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-button type="submit" variant="outline-primary">Submit</b-button>
      <b-button type="button" v-on:click="onReset" variant="outline-danger"
        >Reset</b-button
      >
    </b-form>
  </div>
</template>

<script>
import DataAccess from '@/Services/DataAccess.js'

export default {
  data () {
    return {
      str: null,
      locale: 'es-ES',
      loading: true,
      clients: null,
      series: null,
      dateState: false,
      form: {
        SerieIdentifier: null,
        FechaFactura: null,
        ClienteIdentifier: null
      }
    }
  },
  created () {
    (async () => {
      await DataAccess.getDataMuliplex2('/api/clients', '/api/series')
        .then((responses) => {
          // const responseOne = responses[0]
          // const responseTwo = responses[1]
          this.clients = responses[0].data
          this.series = responses[1].data
          this.loading = false
        })
        .catch((error) => {
          console.log('ERROR: ', error)
        })
    })()
  },
  methods: {
    changeDP () {
      this.dateState = this.form.FechaFactura !== ''
    },
    onReset (evt) {
      // evt.preventDefault()
      // Reset our form values
      this.form.SerieIdentifier = null
      this.form.FechaFactura = null
      this.form.ClienteIdentifier = null
      // Trick to reset/clear native browser form validation state
      this.loading = false
      this.$nextTick(() => {
        this.loading = true
      })
    },
    facturar () {
      (async () => {
        await DataAccess.postData('/api/facturas', JSON.stringify(this.form))
          .then((response) => {
            this.$router.push({ name: 'Factures' })
          })
          .catch((error) => {
            console.log('ERROR: ', error)
          })
      })()
    }
  }
}
</script>

<style scoped>
  .rgFsT {
    color: #262626;
    color: rgba(var(--i1d, 38, 38, 38), 1);
    flex-grow: 1;
    justify-content: center;
    margin-top: 12px;
    max-width: 350px;
    width: 100%;
    margin: 40px auto;
  }

  p {
    color: red;
  }
</style>
